export default {
    url: {
        '/lightning-loan/': 'lightning_loan',
        '/Funding-Circle-Flexiloan/': 'funding_circle'
    }
};
